// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';
require('slick-carousel');

if($('.garden-explorer').length) {

    // var swiper = new Swiper(".explore-group-slider", {
    //     slidesPerView: 1
    // });

    // console.log(swiper);

    $('.garden-explorer').each(function () {
        let navItems = $(this).find('.group-nav-item'),
            gardenGroups = $(this).find('.explore-group');

        navItems.on('click', function () {

            if($(this).hasClass('active')) return true;

            let group = $(this).data('group'),
                newGardenGroup = $('#explore-group-item-' + group);

            navItems.removeClass('active');
            $(this).addClass('active');

            gardenGroups.removeClass('showing');

            setTimeout(function () {
                gardenGroups.addClass('d-none');
                newGardenGroup.removeClass('d-none');
                $('.explore-group-slider').slick('refresh');
            }, 310);

            setTimeout(function () {
                newGardenGroup.addClass('showing');
                $(window).resize();
            }, 320);

        });
    });

    $('.garden-explorer').each(function () {

        let overviewColumn = $(this).find('.overview-column'),
            width = $(window).width() - overviewColumn.width() - 45;

        // console.log(width);

        $('.explore-group').css('width', $('.explore-group').width());

    });

    $('.explore-group').each(function () {

        let sliderElement = $(this).find('.explore-group-slider'),
            sliderPrev = $(this).find('.explore-group-prev'),
            sliderNext = $(this).find('.explore-group-next');

        let slider = sliderElement.slick({
            adaptiveHeight: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
        });

        if($(this).data('group-index') > 0) {
            let group = $(this);
            setTimeout(function () {
                group.addClass('d-none');
            }, 300);
        }

        sliderPrev.on('click', function () {
            slider.slick('slickPrev');
        });

        sliderNext.on('click', function () {
            slider.slick('slickNext');
        });

    });

}
